import React from 'react'
import PageHeader from "../components/PageHeader";
import { sansthanImg } from "../assets/assets.js";
import "../css/janmotsav.css";

export const Janmotsav = () => {
    return (
        <>  
            <PageHeader title=" जन्मोत्सव  " path="/about-goshala" name=" goshala" />
            {/* <Initiatives /> */}
                  <div className="janmotsav-section">
                    <div className="janmotsav-container">
                      {/* container  */}
                      <div className="janmotsav-sub-section">
                        {/* sub-section */}
                        <div className="janmotsav-img-container">
                          <img
                            className="janmotsav-image"
                            src={sansthanImg.s_img08}
                            alt=""
                          />
                        </div>
                        <div className="janmotsav-info-container">
                          <h3>	जन्मोत्सव </h3>
                          <p>
                            &nbsp;&nbsp;&nbsp;&nbsp;पौष शुद्ध द्वादशी या श्रींच्या जन्मदिनी श्रींचा जन्मोत्सव साजरा केला जातो. या सोहळ्याच्या अनुषंगाने प्रतिवर्षी भव्यसप्ताह स्वरूपात अनेक सांस्कृतिक कार्यक्रमांचा आयोजन केल्या जाते. यात प्रामुख्याने यज्ञयाग गोपूजन महा अन्नदान आरोग्य शिबिरे सत्संग कथा व अनेक सामाजिक उपक्रमांचे देखील आयोजन केल्या जात असते.या कार्यक्रमासाठी प्रतिवर्षी हजारोंच्या संख्येने भक्तगण उपस्थित असतात.
                          </p>
                        </div>
                      </div>

 {/* second one  */}
 <div className="chaturmas-sub-section">
                            <hr  className='responsive-divider'/>
                            <div className="youtube-video-container">
                            <iframe width="660" height="415" src="https://www.youtube.com/embed/_kVzI6Btv3w?si=e0gB93RYMNmThmal" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                           </div>
                          </div>

                      {/* second one  */}


            
                      <div className="janmotsav-sub-section"></div>
                    </div>
                  </div>
        </>
    );
}
